import { CONTACT_EMAIL } from "../../../helpers/constants";

const TermsContent = () => (
  <div className="gm-terms-content">
    <h4>Sobre el servicio</h4>
    <p>
      GrowMe es un servicio digital de acceso inmediato que permite realizar
      evaluaciones online y obtener resultados personalizados.
    </p>

    <h4>Importante antes de comenzar</h4>
    <p>
      Una vez que accedes a la plataforma o inicias el test, el servicio se
      considera utilizado. Por esta razón,{" "}
      <strong>no es posible solicitar devoluciones una vez iniciado el test</strong>.
    </p>

    <h4>¿Cuándo sí puede aplicar una devolución?</h4>
    <p>Podremos revisar tu caso si ocurre alguna de estas situaciones:</p>
    <ul>
      <li>Problemas técnicos que impidan usar el test</li>
      <li>Cobros duplicados o errores en el pago</li>
      <li>Dificultades de acceso atribuibles a la plataforma</li>
    </ul>

    <h4>¿Cuándo no aplica devolución?</h4>
    <p>No realizamos devoluciones en los siguientes casos:</p>
    <ul>
      <li>Si ya iniciaste el test o accediste a la plataforma</li>
      <li>Si decides no completar la evaluación</li>
      <li>Si los resultados no cumplen tus expectativas</li>
      <li>Si hubo errores en los datos ingresados</li>
      <li>Si no comprendes los resultados entregados</li>
    </ul>
    <p>Si tienes dudas sobre tu informe, nuestro equipo puede ayudarte a interpretarlo.</p>

    <h4>Planes y evaluaciones</h4>
    <p>Si compraste un plan o paquete:</p>
    <ul>
      <li>Puedes usar tus evaluaciones dentro del período indicado</li>
      <li>Una vez activado, el plan no es reembolsable</li>
      <li>Las evaluaciones no utilizadas no son reembolsables</li>
    </ul>

    <h4>¿Necesitas solicitar una revisión?</h4>
    <p>
      Si tuviste un problema, escríbenos dentro de los{" "}
      <strong>5 a 7 días desde la compra</strong> a:{" "}
      <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
    </p>
    <p>Incluye una breve descripción del problema para poder ayudarte.</p>

    <h4>Estamos para ayudarte</h4>
    <p>
      Antes de solicitar una devolución, te recomendamos contactarnos. Muchas
      veces podemos resolver el problema rápidamente.
    </p>

    <h4>Aceptación</h4>
    <p>Al comprar en Growme, aceptas estas condiciones.</p>
  </div>
);

export default TermsContent;
